import { Controller } from "@hotwired/stimulus"

// Detects the guest's browser time zone (PR C,
// docs/plans/2026-09-27-savant-scheduling.md) and, the first time a guest
// lands on a booking/manage page with no explicit guest_time_zone param yet,
// resubmits the surrounding GET form so the server re-renders slots in that
// zone. The <select> target lets the guest override it afterward — either
// path just updates the hidden field and resubmits.
export default class extends Controller {
  static targets = ["select", "hiddenField"]

  connect() {
    if (this.element.dataset.guestTimezoneExplicit === "true") return
    if (!this.hasHiddenFieldTarget) return

    const detected = this.detectedZone()
    if (!detected || detected === this.hiddenFieldTarget.value) return

    this.hiddenFieldTarget.value = detected
    if (this.hasSelectTarget) this.selectTarget.value = detected
    this.element.requestSubmit()
  }

  change() {
    if (this.hasHiddenFieldTarget && this.hasSelectTarget) {
      this.hiddenFieldTarget.value = this.selectTarget.value
    }
    this.element.requestSubmit()
  }

  detectedZone() {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone
    } catch (_error) {
      return null
    }
  }
}
